import { ALLOWED_ANEXO_PREFIXES, ALLOWED_ANEXO_TYPES, MAX_ANEXO_SIZE_BYTES, PROTOCOLO_LENGTH } from './constants.js';

export const generateProtocolo = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const randomValues = new Uint8Array(PROTOCOLO_LENGTH);
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(randomValues);
  } else {
    for (let i = 0; i < randomValues.length; i += 1) {
      randomValues[i] = Math.floor(Math.random() * 256);
    }
  }
  const randomChars = Array.from(randomValues, value => chars[value % chars.length]).join('');
  return `RTA-${randomChars}`;
};

export const generatePin = () => Math.floor(100000 + Math.random() * 900000).toString();

export const isAllowedAnexoType = (file) => (
  ALLOWED_ANEXO_TYPES.includes(file.type) ||
  ALLOWED_ANEXO_PREFIXES.some(prefix => file.type.startsWith(prefix))
);

export const validateAnexo = (file) => {
  if (!isAllowedAnexoType(file)) {
    return `O arquivo "${file.name}" não é permitido. Use apenas PDF, imagem ou áudio.`;
  }
  if (file.size > MAX_ANEXO_SIZE_BYTES) {
    return `O arquivo "${file.name}" excede o limite de 20 MB.`;
  }
  return null;
};
